import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)); }, []);
  return (
    <div className="p-4 sm:p-6 md:p-8 space-y-6" data-testid="admin-audit-page">
      <div><h1 className="font-display text-3xl font-bold tracking-tight">Audit logs</h1><p className="text-slate-500">Every significant action, tracked</p></div>
      <Card className="border-slate-200"><CardContent className="p-0 divide-y divide-slate-100">
        {logs.map((l) => (
          <div key={l.id} className="p-4 flex items-center justify-between hover:bg-slate-50">
            <div>
              <div className="font-mono text-sm">{l.action}</div>
              <div className="text-xs text-slate-400">{l.tenant_id ? `tenant:${l.tenant_id.slice(0, 8)}` : "system"}</div>
            </div>
            <div className="text-xs text-slate-500 font-mono">{(l.created_at || "").slice(0, 19).replace("T", " ")}</div>
          </div>
        ))}
        {!logs.length && <div className="p-8 text-center text-slate-400">No audit logs yet</div>}
      </CardContent></Card>
    </div>
  );
}
